import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs";
import ErrorSection from "@/components/Errormessage/Errormessage";
import Layout from "@/components/Layout/Layout";
import { fetchCommonData } from "@/services/CommonService";
import {
  getLocaleFromPath,
  getLocaleFromCountry,
  ensureLocalesLoaded,
} from "@/Config/countryConstants";
import { useEffect, useState } from "react";

export default function NotFound() {
  const [commonData, setCommonData] = useState<any>(null);

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      try {
        await ensureLocalesLoaded();
        const pathname =
          typeof window !== "undefined"
            ? window.location?.pathname || "/"
            : "/";
        const pathLocale = getLocaleFromPath(pathname);
        const cookieString =
          typeof document !== "undefined" ? document.cookie || "" : "";
        const selectedMatch = cookieString.match(
          /SelectedCountryByUser=([^;]+)/
        );
        const cookieCountry = selectedMatch
          ? decodeURIComponent(selectedMatch[1])
          : null;
        const effectiveLocale =
          cookieCountry && cookieCountry !== "south-africa"
            ? getLocaleFromCountry(cookieCountry)
            : pathLocale;
        const response = await fetchCommonData(effectiveLocale);
        if (isMounted) {
          setCommonData(response?.data ?? null);
        }
      } catch (err) {
        if (isMounted) setCommonData(null);
        // eslint-disable-next-line no-console
        console.error("Error fetching CMS data (404):", err);
      }
    };
    load();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Layout pageTitle="404 Error" commonData={commonData}>
      <Breadcrumbs hideInnerBox leftAlignDropdown />
      <ErrorSection />
    </Layout>
  );
}
